export const getHoursSince = (
  timestampString?: number,
  inMiliseconds = false
) => {
  if (!timestampString) return;

  const date = new Date(
    inMiliseconds ? timestampString : timestampString * 1000
  );
  const now = Date.now();

  const diffMs = now - date.getTime();
  return Math.floor(diffMs / 3600000);
};

export const getMinutesSince = (timestampString: number | string) => {
  const date = new Date(timestampString);
  const now = new Date();

  const diffMs = now.getTime() - date.getTime();
  return Math.floor(diffMs / 60000);
};

export const getSecondsSince = (timestampString: number | string) => {
  const date = new Date(timestampString);
  const now = new Date();

  const diffMs = now.getTime() - date.getTime();
  return Math.floor(diffMs / 1000);
};
